'use es6';

import { makeChirpEarlyRequest } from 'rpc-client-utils';
import { getPublicAchievementEarlyRequestRpc } from '../__generated__/chirp/com/hubspot/credentials/rpc/earlyRequest/AchievementPublicRpc.early';
import { URL_PATTERN } from './constants/AchievementConstants';
const [__, publicId] = window.location.pathname.match(URL_PATTERN) || [];
if (publicId) {
  void makeChirpEarlyRequest(getPublicAchievementEarlyRequestRpc, {
    request: {
      publicId
    }
  });
}